import * as React from "react";
import { Link, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";

import { ReactComponent as HomeIcon } from "../../image/icons/home.svg";
import { ReactComponent as HomeActiveIcon } from "../../image/icons/homeActive.svg";
import { ReactComponent as RecherchIcon } from "../../image/icons/recherch.svg";
import { ReactComponent as PanierIcon } from "../../image/icons/panier.svg";
import { ReactComponent as PanierActiveIcon } from "../../image/icons/panierActive.svg";
import { ReactComponent as ProfileIcon } from "../../image/icons/profile.svg";

export default function BottomBar() {
  const location = useLocation();
  const [value, setValue] = React.useState(0);

  // set active tab based on current path
  React.useEffect(() => {
    switch (location.pathname) {
      case "/":
        setValue(0);
        break;
      case "/recherche":
        setValue(1);
        break;
      case "/panier":
      case "/commande/inStore":
        setValue(2);
        break;
      case "/profil":
        setValue(3);
        break;
      default:
        setValue(0);
    }
  }, [location.pathname]);

  // حجم الأيقونات
  const iconStyle = { height: 40 };

  return (
    <Box
      sx={{
        width: "100%",
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        bgcolor: "background.paper",
        boxShadow: 3,
        zIndex: 10,
      }}
    >
      <BottomNavigation
        value={value}
        onChange={(event, newValue) => setValue(newValue)}
        showLabels
      >
        <BottomNavigationAction
          icon={
            value === 0 ? (
              <HomeActiveIcon style={iconStyle} />
            ) : (
              <HomeIcon style={iconStyle} />
            )
          }
          component={Link}
          to="/"
        />
        <BottomNavigationAction
          icon={<RecherchIcon style={iconStyle} />}
          component={Link}
          to="/recherche"
        />
        <BottomNavigationAction
          icon={
            value === 2 ? (
              <PanierActiveIcon style={iconStyle} />
            ) : (
              <PanierIcon style={iconStyle} />
            )
          }
          component={Link}
          to="/panier"
        />
        <BottomNavigationAction
          icon={<ProfileIcon style={iconStyle} />}
          component={Link}
          to="/profil"
        />
      </BottomNavigation>
    </Box>
  );
}
